import React from "react";

const fullName = (person) =>
  [person?.firstName, person?.lastName].filter(Boolean).join(" ");

const TableRequestGuests = ({ user, guests = [], notes = "" }) => (
  <section
    className="table-request-guests"
    aria-labelledby="table-request-guests-title"
  >
    <h2 className="table-request-guests__title" id="table-request-guests-title">
      Your guests
    </h2>
    <ul className="table-request-guests__list">
      <li className="table-request-guests__guest">
        <span className="table-request-guests__name">{fullName(user)}</span>
        <span className="table-request-guests__you">You</span>
      </li>
      {guests.map((guest) => (
        <li className="table-request-guests__guest" key={guest.position}>
          <span className="table-request-guests__name">{fullName(guest)}</span>
          {guest.email ? (
            <span className="table-request-guests__email">{guest.email}</span>
          ) : null}
        </li>
      ))}
    </ul>
    {notes ? (
      <div className="table-request-guests__note">
        <h3 className="table-request-guests__note-title">Your note</h3>
        <p className="table-request-guests__note-body">{notes}</p>
      </div>
    ) : null}
  </section>
);

export default TableRequestGuests;
